<div cdkOverlayOrigin #trigger="cdkOverlayOrigin"></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'top', offsetX: -32 }]"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
>
  <!-- fusion Solana -->
  @if (activeBannerList()["fusion-solana"] === true) {
    <div class="relative h-[152px] w-[328px] overflow-auto rounded-2xl" [@tuiSlideInRight]="getAnimation()">
      <img src="/assets/banner/fusion-solana.png" [width]="328" [height]="152" alt="Fusion-Solana" />
      <div
        data-test-id="closeBanner"
        class="text-day-static-white absolute right-0 top-0 cursor-pointer p-3 hover:opacity-50"
        (click)="onCloseBanner('fusion-solana')"
      >
        <svg class="h-4 w-4">
          <use href="/assets/icons/close.svg#img" />
        </svg>
      </div>
      <button
        (click)="onLearnMore('fusion-solana')"
        class="bg-day-static-white text-day-static-black oneinch-text-button-16 absolute bottom-4 left-4 rounded-lg px-6 py-1"
      >
        {{ "banner.fusion-plus.button" | transloco }}
      </button>
    </div>
  }
</ng-template>
